<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-8 text-center">
          <v-icon 
            :color="messageType === 'danger' ? 'error' : 'success'" 
            size="64" 
            class="mb-4"
          >
            {{ messageType === 'danger' ? 'mdi-email-alert' : 'mdi-email-check' }}
          </v-icon>
          
          <v-card-title class="text-h5 mb-4 text-center">
            Подтверждение адреса электронной почты
          </v-card-title>
          
          <v-alert
            v-if="showAlert"
            :type="messageType === 'danger' ? 'error' : 'success'"
            variant="tonal"
            closable
            class="mb-4 text-start"
            @click:close="showAlert = false"
          >
            {{ message }}
          </v-alert>
          
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
            class="mb-4"
          />
          
          <v-btn
            color="primary"
            size="large"
            variant="elevated"
            :to="'/signin'"
            block
          >
            Перейти к входу
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiClient from '@/apiClient';

export default {
  data() {
    return {
      message: '',
      messageType: 'success',
      showAlert: false,
      loading: true
    };
  },
  mounted() {
    // Add a small delay to ensure the store is properly initialized
    setTimeout(() => {
      this.confirmEmail();
    }, 100);
  },
  methods: {
    confirmEmail() {
      const token = this.$route.params.token;
      const routeName = this.$route.name;
      
      // Use the new verify-email endpoint for new verification links
      const endpoint = routeName === 'verify-email' ? `/verify-email/${token}` : `/confirm/${token}`;
      
      apiClient.get(endpoint)
        .then(response => {
          if (response.status === 200) {
            this.showMessage('Почта подтверждена успешно!', false);
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            this.showMessage(error.response.data.detail, true);
          } else {
            this.showMessage('Ошибка подтверждения адреса электронной почты', true);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showMessage(message, isError) {
      this.messageType = isError ? "danger" : "success";
      this.message = message;
      this.showAlert = true;
    }
  }
};
</script>

<style scoped>
/* Vuetify handles styling, minimal custom styles needed */
</style>
